(() => {
  if (window.nuvoraMobileMenuReady) return;
  window.nuvoraMobileMenuReady = true;
  let opener;
  const panel = () => document.querySelector('dialog#header-sidebar-menu');
  function sync(menu) {
    document.querySelectorAll('[aria-controls="header-sidebar-menu"]').forEach(button => button.setAttribute('aria-expanded', String(menu.open)));
    document.documentElement.classList.toggle('nuvora-menu-lock', menu.open);
  }
  function close(menu) {
    if (!menu.open) return;
    menu.close();
    sync(menu);
    opener?.focus({ preventScroll: true });
  }
  document.addEventListener('click', event => {
    const target = event.target.closest?.('[aria-controls="header-sidebar-menu"]');
    const menu = panel();
    if (!menu) return;
    if (target) {
      event.preventDefault();
      event.stopImmediatePropagation();
      opener = target;
      if (menu.open) close(menu);
      else { menu.showModal(); sync(menu); }
      return;
    }
    if (!menu.open) return;
    if (event.target.closest?.('#header-sidebar-menu button[aria-label="Close"],#header-sidebar-menu a[href]')) close(menu);
    else if (event.target === menu) {
      const rect = menu.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX >= rect.right || event.clientY < rect.top || event.clientY >= rect.bottom) close(menu);
    }
  }, true);
  document.addEventListener('cancel', event => {
    if (event.target !== panel()) return;
    event.preventDefault();
    close(event.target);
  }, true);
  document.addEventListener('close', event => { if (event.target === panel()) sync(event.target); }, true);
  window.matchMedia('(min-width: 1150px)').addEventListener('change', event => { if (event.matches && panel()) close(panel()); });
})();
